export default __webpack_public_path__ + "static/media/General.831fe4b8.png";